import { Box, Link, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import JourneysMap from "../components/JourneysMap";
import { getJourneys, reset } from "../features/journeys/journeySlice";
import LoadingOverlay from "../components/LoadingOverlay";
import InsightsPanel from "../components/insights/InsightsPanel";
import JourneyFilter from "../components/JourneyFilter";
import MapWithBottombarLayout from "../components/MapWithBottombarLayout";
import { Helmet } from "react-helmet-async";



export default function Insights() {

    const { user } = useSelector((state) => state.auth)
    const { journeys, isSuccess, isError, actionType } = useSelector((state) => state.journeys)

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [journeysToDisplay, setJourneysToDisplay] = useState([])
    const [homeCountrySetting, setHomeCountrySetting] = useState({ code: 'GB', isPlaceholder: undefined }) // For legacy accounts w/o homeCountry defined
    const [isFreeTier, setIsFreeTier] = useState(true)

    useEffect(() => {
        if (!user) {
            navigate('/login')
            return
        }

        if (user.details.subscription.tier !== 'free-standard')
            setIsFreeTier(false)

        if (user.details.homeCountry) {
            setHomeCountrySetting({ code: user.details.homeCountry.code, isPlaceholder: false })
            // setHomeCountrySetting({ code: user.details.homeCountry, isPlaceholder: true })
        } else {
            setHomeCountrySetting({ code: 'GB', isPlaceholder: true })
        }

        dispatch(getJourneys())

        return () => {
            dispatch(reset())
        }
    }, [user, navigate, dispatch])

    const MyHelmet = () => (
        <Helmet>
            <title>Insights (Beta) | TrainLookout</title>
            <meta name="description" content="Your insights page" />
            <meta name="keywords" content="insights, statistics" />
            <link rel="canonical" href="/myjourneys/insights" />
        </Helmet>
    )

    if (!isSuccess && !isError && actionType === 'get') { // This is probably to change
        return (
            <>
                <MyHelmet />
                <LoadingOverlay type="full" text="Generating insights..." />
            </>
        )
    }

    return (<>
        <MyHelmet />
        <MapWithBottombarLayout
            mapComponent={
                <JourneysMap
                    journeys={journeysToDisplay}
                    previewPoints={{}}

                    isImageDownloadDisabled
                />
            }
            bottombarComponent={
                <>
                    {homeCountrySetting.isPlaceholder === true && (
                        <Box p="4" fontSize="sm" textAlign="center">
                            <Text>
                                You haven't set your home country.{' '}
                                <Link href="/preferences" textDecoration="underline" color="blue.500">
                                    Set it here
                                </Link>{' '}
                                to access more insights.
                                Country-related insights will be based on the United Kingdom in the meantime.
                            </Text>
                        </Box>
                    )}
                    {isFreeTier === true && (
                        <Box pt='2' fontSize="sm" textAlign="center">
                            <Text>
                                You are on our free tier.{' '}
                                Insights are available for all of our users on a temporary basis, until 31st of March.{' '}
                                <br />
                                <Link href="/pricing" textDecoration="underline" color="blue.500" target="_blank" rel="noopener noreferrer">
                                    Upgrade to our All-Country Pass tier
                                </Link>{' '}
                                for continued access to insights & additional features.
                            </Text>
                        </Box>
                    )}

                    <JourneyFilter
                        journeys={journeys}
                        setJourneysToDisplay={setJourneysToDisplay}
                        hideSortOrder
                    />

                    <InsightsPanel
                        journeys={journeysToDisplay}
                        homeCountryCode={homeCountrySetting.code}
                    />
                </>
            }
        />
    </>)
}